import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";

export default function SignupCallWizardConfirmation(props) {
  if (props.state.wizardStep !== "thank-you") {
    return null;
  } else {
    window.onbeforeunload = null;
  }
  return (
    <div className="App confirmationBG">
      <Header />
      <Confirmation currentState={props.state} />
      <Footer confirmation={true} />
    </div>
  );
}

const Confirmation = (props) => {
  const { width, height } = useWindowSize();
  const recycle = false;
  return (
    <div id="about" className="section wide img light confirmation">
      <Confetti width={width} height={height} recycle={recycle} style={{ zIndex: "9999999" }} />
      <div className="wrap confirmation">
        <h2 className="heading-4 confirm">
          You’re all set, {props.currentState.firstName}!<br />
        </h2>
        <div className="confirmationcontainer w-container">
          <h2 className="paragraph-2 confirmation">
            We can’t wait to support your independence.
            <br />
          </h2>

          <h2 style={{ marginBottom: "10px" }} className="paragraph-2 orange">
            What comes next?
            <br />
          </h2>
          <div className="roundStepsContainer">
            <div className="roundSteps">1</div>
          </div>
          <h2 style={{ width: "63%", marginBottom: "20px" }} className="paragraph-2 confirmation">
            A DUOS team member will give you a call shortly for a chat about your needs and our services.
            <br />
          </h2>
          <div className="roundStepsContainer">
            <div className="roundSteps">2</div>
          </div>
          <h2 style={{ width: "63%" }} className="paragraph-2 confirmation">
            We’ll match you with a Duo that fits your specific needs and personality.
            <br />
          </h2>
        </div>
        <a href="https://www.getduos.com/welcome" style={{ fontSize: "22px", color: "#ffffff" }}>
          Back to DUOS
        </a>
      </div>
    </div>
  );
};
